__turbopack_context__.v({
  "root": "StressModal-module__tV303G__root",
});
